import { addDoc, collection, Timestamp } from "firebase/firestore";

import { db } from "./firebase";

export const createUserLog = async (
  uid: string,
  title: string,
  description: string,
  metadata?: any,
  subType?: string
) => {
  try {
    console.log("Creating collection reference...");
    const userLogsCollectionRef = collection(db, "users", uid, "userLogs");
    console.log("Collection path:", userLogsCollectionRef.path);

    const logData = {
      createdAt: Timestamp.now(),
      type: title,
      subType: subType || "",
      description,
      metadata: metadata || {},
    };
    console.log("Log data to write:", logData);

    console.log("Calling addDoc...");
    const newLog = await addDoc(userLogsCollectionRef, logData);
    console.log("✅ Log created successfully! Document ID:", newLog.id);
    console.log("Document path:", newLog.path);
    console.log("=== createUserLog SUCCESS ===");

    return newLog;
  } catch (err) {
    console.error("❌ ERROR in createUserLog:", err);
    if (err instanceof Error) {
      console.error("Error name:", err.name);
      console.error("Error message:", err.message);
      console.error("Error stack:", err.stack);
    }
    if (err && typeof err === "object" && "code" in err) {
      console.error("Firebase error code:", (err as any).code);
    }
    console.error("=== createUserLog FAILED ===");
    throw err;
  }
};

export const createSystemLog = async (title: string, description: string) => {
  try {
    const systemLogsCollectionRef = collection(db, "system_logs");

    const newLog = await addDoc(systemLogsCollectionRef, {
      createdAt: Timestamp.now(),
      type: title,
      description,
    });

    return newLog;
  } catch (err) {
    console.error("Error creating system log:", err);
    throw err;
  }
};
